/**
 * Gucu Tasiyanlar - section script
 * - Scroll ile kademeli (staggered) reveal animasyonu
 * - Dokunmatik cihazlarda hover olmadigi icin tap ile fotografi renklendirme
 * - prefers-reduced-motion tercihine saygi gosterir
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '.section-gucu-tasiyanlar';
  var REVEAL_SELECTOR = '.hsh-wrapper, .gt-fighter, .gt-cta-wrap';

  function initSection(section) {
    var prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!prefersReducedMotion && 'IntersectionObserver' in window) {
      section.classList.add('gt-observe');

      var targets = section.querySelectorAll(REVEAL_SELECTOR);
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var delay = 0;
              if (entry.target.classList.contains('gt-fighter')) {
                var index = Array.prototype.indexOf.call(
                  section.querySelectorAll('.gt-fighter'),
                  entry.target,
                );
                delay = index * 110;
              }
              window.setTimeout(function () {
                entry.target.classList.add('is-visible');
              }, delay);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' },
      );

      targets.forEach(function (el) {
        observer.observe(el);
      });
    }

    // Dokunmatik cihazlarda hover yerine tap ile fotografi renklendir.
    var fighters = section.querySelectorAll('.gt-fighter');
    fighters.forEach(function (fighter) {
      fighter.addEventListener('click', function (event) {
        var isTouch = window.matchMedia && window.matchMedia('(hover: none)').matches;
        if (!isTouch) return;

        var isLink = event.target.closest('a');
        var alreadyActive = fighter.classList.contains('is-active');

        if (isLink && !alreadyActive) {
          event.preventDefault();
        }

        fighters.forEach(function (f) {
          if (f !== fighter) f.classList.remove('is-active');
        });
        fighter.classList.toggle('is-active');
      });
    });
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify tema duzenleyicisi (theme editor) section'i yeniden yukledigi zaman tekrar calistir.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
